import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { useBids } from "@mibuildweb/hooks";
import { useCreateBidContext } from "../CreateBidContext";

export const useAreaTemplateViewModel = ({
  handleCloseModal,
}: UseAreaTemplateViewModelProps) => {
  const stateManager = useComponentState();
  const { form } = useCreateBidContext();
  const { getValues } = form;
  const data = getValues();

  const { createAreaTemplate } = useBids();

  const handleCreateAreaTemplate = async (areaTemplateName: string) => {
    const modifiedData = {
      ...data,
      id: undefined,
      options: undefined,
      name: areaTemplateName,
      planAreas: data.planAreas.map((area) => ({
        ...area,
        id: undefined,
        materials: [],
      })),
    };
    const response = await createAreaTemplate(modifiedData as any);
    if (response.status === HTTP_STATUSES.OK) {
      handleCloseModal();
    }
  };

  return {
    isLoading: stateManager.isBusy(),
    handleCreateAreaTemplate,
  };
};

interface UseAreaTemplateViewModelProps {
  handleCloseModal: () => void;
}
